import { render, staticRenderFns } from "./URLsSales.vue?vue&type=template&id=2f190513&"
import script from "./URLsSales.vue?vue&type=script&lang=js&"
export * from "./URLsSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports